<div mat-dialog-title class="dialog-info">
  <label class="dialogTitle">
    {{'EXPORT_NOTES_DIALOG.TITLE' | translate}}
  </label>
  <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>

<div class="row container-fluid padding-right-0">
  <div class="col-md-12 padding-right-0">
    <mat-dialog-content class="contentPadding">
      <mat-radio-group [(ngModel)]="notes" class="radio-row">
        <mat-radio-button [value]="true">{{'EXPORT_NOTES_DIALOG.ADD_NOTES' | translate}}</mat-radio-button>
        <mat-radio-button [value]="false" class="ml-3">{{'EXPORT_NOTES_DIALOG.DO_NOT_ADD_NOTES' | translate}}</mat-radio-button>
      </mat-radio-group>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="actionsPadding">
      <button class="openCloseBtn" mat-raised-button color="primary" (click)="onConfirm()">{{'COMMON_DIALOGS_BTN_LABELS.OK' | translate}}</button>
      <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>{{'COMMON_DIALOGS_BTN_LABELS.CANCEL' | translate}}</button>
    </mat-dialog-actions>
  </div>
</div>